<template>
  <div>
    <!-- 考试选择器 -->
    <el-dialog title="批量选择考试" :visible.sync="isShow" width="70%" @submit.native.prevent>
      <el-form
        ref="correlationExamFormRef"
        :model="dataForm"
        label-width="80px"
      >
        <el-row>
          <el-col :span="6">
            <el-form-item label="试卷名称" prop="questionsPaperName">
              <el-input
                v-model="dataForm.questionsPaperName"
                @keyup.enter.native="search"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="试卷编号" prop="paperNumber">
              <el-input v-model="dataForm.paperNumber"   @keyup.enter.native="search"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" class="pr20">
            <el-form-item label="所属目录" prop="questionsDirectoryId">
              <selectTree
                clearable
                :props="{
                    value: 'id', // ID字段名
                    label: 'directoryName', // 显示名称
                    children: 'directoryList' // 子级字段名
                  }"
                :options="directoryList"
                :value="dataForm.questionsDirectoryId"
                @getValue="selectDirectoryChange"
              ></selectTree>
            </el-form-item>
          </el-col>

<!--          <el-col :span="6">-->
<!--            <el-form-item label="试卷类型" prop="selectionMode">-->
<!--              <el-select v-model="dataForm.selectionMode" clearable>-->
<!--                <el-option label="随机试卷" value="0"></el-option>-->
<!--                <el-option label="固定试卷" value="1"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--          <el-col :span="6">-->
<!--            <el-form-item label="是否开卷" prop="openBook" class="item">-->
<!--              <el-select v-model="dataForm.openBook" clearable>-->
<!--                <el-option label="开卷" value="0"></el-option>-->
<!--                <el-option label="闭卷" value="1"></el-option>-->
<!--              </el-select>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
          <el-col :span="3">
            <el-form-item>
              <el-button type="primary" @click="search">搜索</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <!-- 资源列表 -->
      <div v-loading="tableLoading" element-loading-text="拼命加载中" >
        <el-table :data="dataList" @selection-change="selectionChange" :row-key="getRowKeys" ref="multipleTable" v-if="isTableShow"  height="510">
          <el-table-column type="selection" :reserve-selection="true"></el-table-column>
          <el-table-column
            property="questionsPaperName"
            label="试卷名称"
          ></el-table-column>
          <el-table-column
            property="questionNumber"
            label="试题数"
          ></el-table-column>
          <el-table-column
            label="分数"
            prop="questionFractionTotal"
          ></el-table-column>
          <el-table-column label="时长（分）" prop="examTime">
            <template slot-scope="scope">
            <span v-if="scope.row.examTime && scope.row.examTime > 0" v-html="scope.row.examTime">
             </span>
              <span v-else>
              不限制
            </span>
            </template>
          </el-table-column>
          <el-table-column
            label="所属目录"
            prop="directoryName"
          ></el-table-column>
        </el-table>
        <el-pagination
          background
          style="margin-top:20px; float:right;"
          @size-change="sizeChange"
          :current-page="page"
          @current-change="pageChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>

      </div>

      <batchBox title="选中试卷" :props="batchBoxProps" @selection-change="batchBoxChange" ref="batchBox"></batchBox>
      <span slot="footer" style="text-align: center; margin-top: 30px" class="p10">
        <el-button @click="isShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import examApi from "@/api/mall/exam.js";
import batchBox from '@/pages/mall/component/batchBox.vue';
import selectTree from "@/components/common/selectTree";

export default {
  name: "examSelector",
  components: {batchBox, selectTree},
  data() {
    return {
      isShow: false,
      dataForm: {
        questionsPaperName:  undefined,
        paperNumber: undefined,
        questionsDirectoryId:  undefined
      },
      categoryList: [],
      dataList: [],
      directoryList: [], // 试卷目录
      total: 0,
      pageSize: 10,
      page: 1,

      tableLoading: false,
      options: [],
      selectDataList: [],
      isTableShow: true,
      batchBoxProps: {
        value: 'id',      // ID字段名
        label: 'questionsPaperName',   // 显示名称
      }
    }
  },
  methods: {
    tableReload(){
      this.dataList = JSON.parse(JSON.stringify(this.dataList));
    },
    search(){
      this.page = 1;
      this.getDataList();
    },
    //获取资料列表
    getDataList() {
      let p = {
        ...this.dataForm,
        page: this.page,
        pageSize: this.pageSize,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      };
      this.tableLoading = true;
      examApi.getPaperList(p).then(res => {
        this.dataList = res.data.records;
        this.total = res.data.total;
        this.tableLoading = false;
      });

    },
    pageChange(e) {
      this.page = e;
      this.getDataList();
    },
    sizeChange(e) {
      this.pageSize = e;
      this.search();
    },
    selectDirectoryChange(v){
      if (v && v.id){
        this.dataForm.questionsDirectoryId = v.id;
      } else {
        this.dataForm.questionsDirectoryId = undefined;
      }
    },
    //重置表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    selectionChange(e) {
      this.selectDataList = e;
      this.$refs.batchBox.setSelection(e);
    },
    batchBoxChange(rows){
      if (this.selectDataList){
        this.$refs.multipleTable.clearSelection();
      }
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
        this.tableReload();
      }
    },
    setSelection(rows){
      this.$nextTick().then(() => {
        this.$refs.multipleTable.clearSelection();
        if (rows) {
          rows.forEach(row => {
            if (row.questionsPaperId) {
              row.id = row.questionsPaperId;
            }
            this.$refs.multipleTable.toggleRowSelection(row);
          });
          this.tableReload();
        }
      });
    },
    show(){
      this.isShow = true;
    },
    getRowKeys(row){
      return row.id;
    },
    confirm() {
      this.$emit("confirm", this.selectDataList);
      this.isShow = false;
    },
    /**
     * 初始化目录列表
     */
    initDirectoryList(){
      examApi.getCatalogList({
        type: 1,
        // enterpriseId: JSON.parse(localStorage.getItem("userinfo")).enterpriseId
      }).then(res => {
          this.directoryList = res.data;
        });
    }
  },
  mounted() {
    this.categoryList = JSON.parse(localStorage.getItem("categoryList"));
    this.initDirectoryList();
    this.search();
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/pages/mall/component/examSelector.vue